import { render, staticRenderFns } from "./AllowanceImport.vue?vue&type=template&id=681fc7e0"
import script from "./AllowanceImport.vue?vue&type=script&lang=js"
export * from "./AllowanceImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports